import styled from 'styled-components';
import device from '../../../components/mediaQueries';

const Wrapper = styled.div`
  position: fixed;
  z-index: 5;
  width: 100%;
  height: 40px;
  border: 1px solid #eceeef;
  background-color: #eceeef;
  width: 100%;
  margin: auto;
  left: 50%;
  transform: translateX(-50%);

  ${device.desktop`
    top: 165px;
  `}
  ${device.mobile`
    top: 40px;
  `}
  text-align: center;
  padding-top: 13px;
`;

export default Wrapper;
